import React from 'react'

const MinusIcon = () => {
	return (
		<svg width={29} height={29} viewBox='0 0 29 29' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<circle cx={14.5} cy={14.5} r={13.5} fill='#fff' stroke='currentColor' strokeWidth={2} />
			<path d='M19.334 15.082v-1.709H9.588v1.709h9.746z' fill='currentColor' />
		</svg>
	)
}

export default MinusIcon
